import { isValidPhoneNumber } from 'libphonenumber-js';
import { Input, type InputProps } from '@/components/common/Input';

interface PhoneInputProps extends Omit<InputProps, 'type' | 'error'> {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

/**
 * Phone input with live E.164 validation via libphonenumber-js. The
 * library accepts both pretty and pure-digit forms; we delegate the
 * "looks like a real phone number" judgement to it rather than a brittle
 * regex. Empty values render no error to avoid yelling at the operator
 * before they've typed.
 */
export function PhoneInput({ value, onChange, error, ...rest }: PhoneInputProps) {
  const liveError =
    value.trim().length > 0 && !isValidPhoneNumber(value.trim())
      ? 'Invalid phone number — include the country code (e.g. +33…)'
      : undefined;
  return (
    <Input
      type="text"
      value={value}
      onChange={onChange}
      error={error ?? liveError}
      placeholder={rest.placeholder ?? '+XX XXX XXX XXXX'}
      {...rest}
    />
  );
}

export function isPhoneValid(value: string | null | undefined): boolean {
  if (!value) return true;
  const trimmed = value.trim();
  if (trimmed.length === 0) return true;
  return isValidPhoneNumber(trimmed);
}
